// src/components/PlanosPagamento/EstudantesPlanoLista.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
  Typography,
  Chip,
  CircularProgress,
  Alert
} from '@mui/material';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import planosPagamentoService from '../../services/planosPagamentoService';
import { formatarMoeda } from '../../utils/formatters';

const EstudantesPlanoLista = () => {
  const { planoId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [estatisticas, setEstatisticas] = useState(null);

  useEffect(() => {
    const carregarDados = async () => {
      try {
        setLoading(true);
        const response = await planosPagamentoService.obterEstatisticasPlano(planoId);
        setEstatisticas(response.data);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        setError('Falha ao carregar a lista de estudantes.');
      } finally {
        setLoading(false);
      }
    };
    carregarDados();
  }, [planoId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Botão de Voltar */}
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/dashboard')}
        sx={{ mb: 3 }}
        variant="outlined"
      >
        Voltar ao Dashboard
      </Button>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom>
          Estudantes do Plano
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {estatisticas?.estatisticas?.estudantes?.length || 0} estudantes encontrados
        </Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Estudante</TableCell>
              <TableCell align="right">Total a Pagar</TableCell>
              <TableCell align="right">Total Pago</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Último Pagamento</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {estatisticas?.estatisticas?.estudantes?.map((estudante) => (
              <TableRow key={estudante.id}>
                <TableCell>{estudante.nome}</TableCell>
                <TableCell align="right">
                  {formatarMoeda(estudante.valorTotal)}
                </TableCell>
                <TableCell align="right">
                  {formatarMoeda(estudante.totalPago)}
                </TableCell>
                <TableCell>
                  <Chip
                    label={estudante.status === 'EM_DIA' ? 'Em dia' : 'Em atraso'}
                    color={estudante.status === 'EM_DIA' ? 'success' : 'warning'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  {estudante.ultimoPagamento ? 
                    new Date(estudante.ultimoPagamento).toLocaleDateString() : 
                    'Nenhum pagamento'
                  }
                </TableCell>
                <TableCell align="center">
                  <Button
                    size="small"
                    variant="outlined"
                    component={Link}
                    to={`/planos-pagamento/${planoId}/estudante/${estudante.id}`}
                  >
                    Ver Detalhes
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default EstudantesPlanoLista;